import { render, staticRenderFns } from "./ques2_2.vue?vue&type=template&id=00ce9cfd&scoped=true"
import script from "./ques2_2.vue?vue&type=script&lang=js"
export * from "./ques2_2.vue?vue&type=script&lang=js"
import style1 from "./ques2_2.vue?vue&type=style&index=1&id=00ce9cfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce9cfd",
  null
  
)

export default component.exports